<template>
   <hic-list-page title="检治项目维护" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="请输入名称或编码">
    <template slot="buttons">

      <el-button type="primary" @click="create" size="small"> <i class="el-icon-plus"></i> 新建 </el-button>
    </template>

      <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row, scope.$index)" />
            <hic-regret-button type="danger" icon="el-icon-delete" circle plain @click="del(scope.row, scope.$index)" :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>
            <el-tag v-if="!scope.row.id" size="mini" type="info">已删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="name" min-width="300">
          <template slot-scope="{ row }">
            <b>{{ row.name }}</b>
          </template>
        </el-table-column>
        <el-table-column label="编码" prop="code" width="100" align="left">
          <template slot-scope="{ row }">
            {{ row.code }}
          </template>
        </el-table-column>

        <el-table-column label="项目源类型" prop="srcType" width="150" align="center" :filter-multiple="false" :filters="dictEnum.ExamineSrcType" column-key="srcType">
          <template slot-scope="{ row }">
            {{ row.srcType }}
          </template>
        </el-table-column>

        <el-table-column label="检查部位" prop="parts" width="150" align="center" :filter-multiple="false">
          <template slot-scope="{ row }">
            {{ row.parts | dictText("Parts") }}
          </template>
        </el-table-column>

        <el-table-column label="助记符" prop="mnemonic" width="150" align="center" >
          <template slot-scope="{ row }">
            {{ row.mnemonic }}
          </template>
        </el-table-column>

        <el-table-column label="执行科室" prop="execDeptCode" width="150" align="center" :filter-multiple="false" :filters="dict.Dept" column-key="execDeptCode">
          <template slot-scope="{ row }">
            {{ row.execDeptCode | dictText("Dept") }}
          </template>
        </el-table-column>

        <el-table-column label="申请类型" prop="appType" width="150" align="center" :filter-multiple="false" :filters="dict.AppType" column-key="appType">
          <template slot-scope="{ row }">
            {{ row.appType | dictText("AppType") }}
          </template>
        </el-table-column>

        <el-table-column label="检治类型" prop="examineType" width="150" align="center" :filter-multiple="false" :filters="dict.ExamineType" column-key="examineType">
          <template slot-scope="{ row }">
            {{ row.examineType | dictText("ExamineType") }}
          </template>
        </el-table-column>

        <el-table-column label="检治项目类型" prop="examineItemType" width="150" align="center" :filter-multiple="false" :filters="dict.ExamineItemType" column-key="examineItemType">
          <template slot-scope="{ row }">
            {{ row.examineItemType | dictText("ExamineItemType") }}
          </template>
        </el-table-column>

        <el-table-column label="标本类型" prop="specimenType" width="150" align="center" :filter-multiple="false" :filters="dict.SpecimenType" column-key="specimenType">
          <template slot-scope="{ row }">
            {{ row.specimenType | dictText("SpecimenType") }}
          </template>
        </el-table-column>

        <el-table-column label="项目源编码" prop="srcCode" width="150" align="center" :filter-multiple="false">
          <template slot-scope="{ row }">
            {{ row.srcCode }}
          </template>
        </el-table-column>

        <el-table-column label="性别" prop="gender" width="150" align="center" :filter-multiple="false" column-key="gender" :filters="dict.Gender">
          <template slot-scope="{ row }">
            {{ row.gender | dictText("Gender") }}
          </template>
        </el-table-column>

        <el-table-column label="天数" prop="days" width="150" align="center" :filter-multiple="false" column-key="days">
          <template slot-scope="{ row }">
            {{ row.days }}
          </template>
        </el-table-column>

        <el-table-column label="取报告时间" prop="reportDelay" width="250" align="center" :filter-multiple="false">
          <template slot-scope="{ row }">
            {{ row.reportDelay }}
          </template>
        </el-table-column>

        <el-table-column label="备注" prop="memo" width="150" align="center" :filter-multiple="false">
          <template slot-scope="{ row }">
            {{ row.memo }}
          </template>
        </el-table-column>

        <el-table-column label="标准类型" prop="type" width="150" align="center" :filter-multiple="false" :filters="dictEnum.examineStandardType" column-key="type">
          <template slot-scope="{ row }">
            {{ row.type }}
          </template>
        </el-table-column>
   

    <examineItem-edit :visible.sync="showEditor" :examineItem="entity" @ok="ok" />

  </hic-list-page>

</template>

<script>
  import api from "./api.js";
  import store from "@/common/store";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      "examineItem-edit": () => import("./edit"),
    },
    data() {
      return {
        showEditor: false,
        showRoles: false,
        entities: {},
        entity: {},
        condition: {
          keyword: null,
          deptCode: null,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        meta:{
          loading: false,
        },

        editingIndex: -1,
      };
    },
    computed: {
      ...mapGetters(["dict", "permission", "dictEnum"]),
    },
    created: function () {
      this.$store.dispatch("loadDicts", ["Dept", "Gender", "ExamineItemType", "DoctorPosition", "SpecimenType", "ExamineType", "AppType", "CheckWay", "Parts"]);
    },
    methods: {
      rowClick(row) {
        if (this.isSwitch) {
          this.$set(row, "isProduce", !row.isProduce);
        }
      },
      tableRowClassName({ row, rowIndex }) {
        if (this.isSwitch) {
          if (row.isProduce) {
            return "active-row";
          }
          return "shover-row";
        }
      },
      page: function () {
        let _this = this;
        this.meta.loading = true;
        api
          .Item.query(this.condition)
          .then((res) => {
            _this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      create: function () {
        this.editingIndex = 0;
        this.entity = {
          id: null,
          joinDate: new Date(),
          price: "",
        };
        this.showEditor = true;
      },
      edit(row, index) {
        this.entity = JSON.parse(JSON.stringify(row));
        this.showEditor = true;
      },
      ok(newEntity) {
        this.searchEntities();
      },
      del: function (row, index) {
        let _this = this;
        api.Item.del(row.id).then((res) => {
          _this.entities.items.splice(index, 1, {});
          _this.$message.success("删除成功！");
        });
      },
      bingRole(row) {
        this.entity = row;
        this.showRoles = true;
      },
 
    },
  };
</script>

<style scoped>
  .el-table /deep/ .active-row {
    background: #f5f7fa;
    cursor: pointer;
    color: #66b1ff;
  }
  .el-table /deep/ .shover-row {
    cursor: pointer;
  }
  .el-table-filter {
    max-height: 10rem;
  }
</style>
